"use client";

import { Anchor, Root, Trigger } from "@radix-ui/react-popover";

import Arrow from "./Arrow";
import Content from "./Content";

export {
  Anchor as PopoverAnchor,
  type PopoverAnchorProps,
  Root as PopoverRoot,
  type PopoverProps as PopoverRootProps,
  type PopoverTriggerProps,
  Trigger as PopoverTrigger,
} from "@radix-ui/react-popover";
export { default as PopoverArrow, type PopoverArrowProps } from "./Arrow";
export { default as PopoverContent, type PopoverContentProps } from "./Content";

export const Popover = {
  Root,
  Trigger,
  Anchor,
  Content,
  Arrow,
};
